import * as React from "react";
import { ColorPicker, Input, Label } from "uxp/components";
import { IBaseProperty, IUIPropertyDefinition } from '../common';
import { CustomColorPicker } from "./common";
import { WidgetDesignerPillInput } from "../pill-input/PillInput";

interface ITextProperty extends IBaseProperty {
    text: string;
    fontSize: string;
    textColor: string;
    backgroundColor: string;
}

interface ITextFieldPropertySettings {
    isTextHidden?: boolean,
    isBackgroundColorHidden?: boolean,
    isFontSizeHidden?: boolean,
    isTextColorVisible?: boolean,
    useCustomColorPicker: boolean,
}

const defaultSettings: ITextFieldPropertySettings = {
    isTextHidden: false,
    isBackgroundColorHidden: false,
    isFontSizeHidden: false,
    isTextColorVisible: false,
    useCustomColorPicker: false
}

export function TextFieldProperty(title: string, props: ITextProperty, settings: ITextFieldPropertySettings = defaultSettings): IUIPropertyDefinition<ITextProperty> {
    return {
        defaults: props,
        render: (props, uxpContext, contextData, containerId, customProps) => {
            const ColorChooser: any = settings?.useCustomColorPicker ? CustomColorPicker : ColorPicker

            return <div className='wd-prop-item'>
                <div className='wd-prop-item-title'>{title}</div>
                {!settings?.isTextHidden && <div className='wd-prop-item-editor'>
                    <Label>Text</Label>
                    {/* <Input
                        value={props.uiProps.text || ''}
                        onChange={s => props.onChange(Object.assign({}, props.uiProps, { text: s }))}
                        className="widget-designer-input"
                    /> */}

                    <WidgetDesignerPillInput
                        value={props.uiProps.text || ''}
                        onChange={s => props.onChange(Object.assign({}, props.uiProps, { text: s }))}
                        className="widget-designer-input"
                        contextData={contextData}
                        showThemes={true}
                    />

                </div>}
                {
                    !settings?.isTextColorVisible && <div className='wd-prop-item-editor'>
                        <Label>Text Color</Label>
                        <ColorChooser contextData={props.contextData}
                            color={props.uiProps.textColor || ''}
                            onChange={(s: any) => props.onChange(Object.assign({}, props.uiProps, { textColor: s }))}
                        />
                    </div>
                }

                {
                    !settings?.isBackgroundColorHidden && <div className='wd-prop-item-editor'>
                        <Label>Background Color</Label>
                        <ColorChooser contextData={props.contextData}
                            color={props.uiProps.backgroundColor || ''}
                            onChange={(s: any) => props.onChange(Object.assign({}, props.uiProps, { backgroundColor: s }))}
                        />
                    </div>
                }

                {
                    !settings?.isFontSizeHidden && <div className='wd-prop-item-editor'>
                        <Label>Fontsize (in px)</Label>
                        <Input
                            type='number'
                            value={props.uiProps.fontSize}
                            onChange={s => {
                                let num = Number(s) || 0
                                if (num < 8) s = '8'
                                else if (num > 200) s = '200'
                                props.onChange(Object.assign({}, props.uiProps, { fontSize: s }))
                            }}
                            className="widget-designer-input"
                            inputAttr={{
                                max: '200',
                                min: '8'
                            }}
                        />
                    </div>
                }
            </div>;
        }
    };
}